import { UUID } from "io-ts-types/lib/UUID"
import { createRequest, platform } from "@shared/platform-api/requests"
import { createRequestHook } from "../../createRequestHook"
import { FleetStats } from "./types"
import { useApi } from "../../../contexts/hooks/useApi"

export type FleetStatsInput = { id: UUID }

const fleetStats = createRequest<FleetStatsInput, FleetStats>(async (input, getToken) =>
  platform(getToken).fleets.fleetStats(input)
)

export const useFleetStats = (input: FleetStatsInput) => {
  const [res, reload] = createRequestHook(fleetStats)(input)
  return useApi<FleetStats, FleetStatsInput>(res, reload)
}
